import { useNavigate } from 'react-router-dom';
import { useComputeCredit } from '../context/ComputeCreditContext.jsx';

// Compute-credit readout + a clear "Add credits" CTA in the TopBar.
// The meter is clickable — it links to /app/billing where the user can buy
// a plan or top up. Display-only reads are server-backed; the server is the
// source of truth for every debit (see ComputeCreditContext.jsx header).
export default function ComputeCreditMeter() {
  const { wallet, loading } = useComputeCredit();
  const navigate = useNavigate();

  if (loading && !wallet) {
    return <div className="aq-credit-meter">Loading credit…</div>;
  }
  if (!wallet) {
    return (
      <div className="aq-credit-meter">
        <span className="aq-credit-meter-value">Credit —</span>
        <button className="aq-btn aq-btn--primary aq-btn--sm" onClick={() => navigate('/app/billing')}>
          Add credits
        </button>
      </div>
    );
  }

  const monthlyCredit = { payg: 0, analyst: 50, pro: 120 }[wallet.tier] || 0;
  const pct = monthlyCredit > 0 ? Math.min(100, Math.round((wallet.balanceUsd / monthlyCredit) * 100)) : 0;
  const isLow = wallet.balanceUsd < 2; // near-empty -> prompt to top up

  return (
    <div className={`aq-credit-meter ${isLow ? 'aq-credit-meter--low' : ''}`} title={`${wallet.tier.toUpperCase()} seat`}>
      <button className="aq-credit-meter-main" onClick={() => navigate('/app/billing')}>
        <span className="aq-credit-meter-value">
          Compute credit <strong className="num">${wallet.balanceUsd.toFixed(2)}</strong>
        </span>
        {monthlyCredit > 0 && (
          <span className="aq-credit-meter-bar">
            <span className="aq-credit-meter-fill" style={{ width: `${pct}%` }} />
          </span>
        )}
        <span className="aq-credit-meter-cta">{isLow ? 'Add credits' : 'Top up · Upgrade'}</span>
      </button>
    </div>
  );
}
